import { createContext, useContext, type ReactNode } from "react";
export type Detail = {
  kicker: string;
  title: string;
  body: ReactNode;
};
export type RefTarget = number | "limitations" | "pi" | "compliance" | null;
export type SnakApi = {
  page: number;
  total: number;
  playing: boolean;
  reduced: boolean;
  go: (n: number) => void;
  next: () => void;
  prev: () => void;
  togglePlay: () => void;
  /** Pause the story because the user started exploring on the page. */
  explore: () => void;
  openDetail: (d: Detail) => void;
  openRefs: (target?: RefTarget) => void;
  openChapters: () => void;
};
export const SnakContext = createContext<SnakApi | null>(null);
export function useSnak() {
  const ctx = useContext(SnakContext);
  if (!ctx) throw new Error("useSnak must be used inside SnakContext");
  return ctx;
}